// Elintra — Root App | v3.2 | Boot sequence + route dispatch
// FIX: Removed useEffect that hijacked routing to 'onboarding' on mount.
// The store's initial route: '' correctly renders LandingPage first.
// No useEffect needed — Zustand initializes synchronously.

import { useAppStore } from '@/store/appStore';
import { LandingPage }    from '@/pages/LandingPage';
import { OnboardingFlow } from '@/pages/OnboardingFlow';
import { DashboardShell } from '@/pages/dashboard/DashboardShell';
import type { Route, User } from '@/types/app';

export default function App() {
  const route    = useAppStore((s) => s.route);
  const setRoute = useAppStore((s) => s.setRoute);
  const setUser  = useAppStore((s) => s.setUser);
  const queries  = useAppStore((s) => s.liveQueries);
  const hist     = useAppStore((s) => s.historicalQueries);

  const handleNavigate = (r: Route) => setRoute(r);

  const handleOnboardingComplete = (user: User) => {
    setUser(user);
    setRoute('app');
  };

  const totalQueries = queries.length + hist.length;

  // route === '' → LandingPage (default Zustand initial state)
  if (!route) {
    return (
      <LandingPage
        totalQueries={totalQueries}
        onNavigate={handleNavigate}
      />
    );
  }

  if (route === 'onboarding') {
    return (
      <OnboardingFlow
        onNavigate={handleNavigate}
        onComplete={handleOnboardingComplete}
      />
    );
  }

  if (route.startsWith('app')) {
    return <DashboardShell onNavigate={handleNavigate} />;
  }

  // Fallback safety — any unknown route goes to landing
  return (
    <LandingPage
      totalQueries={totalQueries}
      onNavigate={handleNavigate}
    />
  );
}
